import { ALLOWED_FILE_TYPES, ALLOWED_FILE_TYPES_KEYS, MAX_FILE_SIZE } from 'cpool-constants';

// Friendly labels per MIME type; jpeg/jpg collapse to a single "JPG" so the hint stays readable.
const MIME_LABEL: Partial<Record<string, string>> = {
    [ALLOWED_FILE_TYPES_KEYS.CSV]: 'CSV',
    [ALLOWED_FILE_TYPES_KEYS.DOCX]: 'DOCX',
    [ALLOWED_FILE_TYPES_KEYS.JPEG]: 'JPG',
    [ALLOWED_FILE_TYPES_KEYS.JPG]: 'JPG',
    [ALLOWED_FILE_TYPES_KEYS.PDF]: 'PDF',
    [ALLOWED_FILE_TYPES_KEYS.PNG]: 'PNG',
    [ALLOWED_FILE_TYPES_KEYS.PPT]: 'PPT',
    [ALLOWED_FILE_TYPES_KEYS.PPTX]: 'PPTX',
    [ALLOWED_FILE_TYPES_KEYS.TXT]: 'TXT',
    [ALLOWED_FILE_TYPES_KEYS.WORD]: 'DOC',
    [ALLOWED_FILE_TYPES_KEYS.XLS]: 'XLS',
    [ALLOWED_FILE_TYPES_KEYS.XLSX]: 'XLSX',
};

export const acceptedFormatLabels = (accept?: readonly string[] | null): string => {
    const mimeTypes = accept && accept.length > 0 ? accept : ALLOWED_FILE_TYPES;
    const labels = mimeTypes.map((mimeType) => MIME_LABEL[mimeType]).filter((label): label is string => !!label);
    return [...new Set(labels)].sort().join(', ');
};

export const maxFileSizeInMb = (size: number = MAX_FILE_SIZE): number => Math.round(size / 1024 / 1024);

const KILOBYTE = 1024;
const MEGABYTE = KILOBYTE * 1024;

export const formatFileSize = (bytes: number): string => {
    if (bytes >= MEGABYTE) return `${Math.round((bytes / MEGABYTE) * 10) / 10} MB`;
    return `${Math.max(1, Math.round(bytes / KILOBYTE))} KB`;
};
